<template>
  <div class="section">
    <div class="container">
      <div class="block mb-4">
        <h1 class="title has-text-centered">Impressum</h1>
        <hr />
      </div>
      <div class="block">
        <div class="card mb-5">
          <div class="card-content">
            <div class="title">Verantwortlicher</div>
            <div class="content">
              Verantwortlich für den Seiteninhalt: Prof. Dr. Klaus Goldhammer,
              Dr. André Wiegand<br />
              Goldmedia GmbH Strategy Consulting<br />
              UmSt.-ID: DE 813765996<br />
              HRB: 88984 AG Berlin-Charlottenburg<br />
              Goldmedia-Gruppe
            </div>
          </div>
        </div>
        <div class="card">
          <div class="card-content">
            <div class="title">Goldmedia GmbH Strategy Consulting</div>
            <div class="content">
              Oranienburger Str. 27, 10117 Berlin<br />
              Tel.: <a href="tel:+49302462660">+49-30-246 266-0</a><br />
              Fax: +49-30-246 266-66<br />
              <a href="mailto:info@goldmedia.de">Info@Goldmedia.de</a><br />
              <a href="http://www.goldmedia.com">www.Goldmedia.com</a><br />
              Geschäftsführung: Prof. Dr. Klaus Goldhammer, Dr. André Wiegand<br />
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: 'Impressum',
};
</script>
